import { render, staticRenderFns } from "./ProformaFeaturesGenerating.vue?vue&type=template&id=2da1666a&"
import script from "./ProformaFeaturesGenerating.vue?vue&type=script&lang=js&"
export * from "./ProformaFeaturesGenerating.vue?vue&type=script&lang=js&"
import style0 from "./ProformaFeaturesGenerating.vue?vue&type=style&index=0&id=2da1666a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports